package com.nonopn.skywatcher.maps.providers

class VaisalaProvider(
) : AbstractMapProvider("vaisala") {
    var options: List<VaisalaProviderOptions> = emptyList()

    override suspend fun buildUrl(row: Int, col: Int, zoomLvl: Int): String {
        val actualOptions = (options + VaisalaProviderOptions.RadarGlobal)
            .sortedBy { it.priority }
            .joinToString(",") { it.value }

        val path = "${zoomLvl + 1}/$col/$row"
        val url = "https://maps.aerisapi.com/" +
                "RG0Q6miYG6Wdpd3q6SZdm_kWFXZNEFkChmOUWLJITq8KHA1y6k9TVDWCDwKghG" +
                "/${actualOptions}/${path}/current.png"
        //"/satellite,radar-global,wind-dir/${path}/current.png"
        //"/lightning-strike-density,radar-global,wind-dir/${path}/current.png"
        //"/flat-dk,water-depth,radar,admin-cities-dk,wind-dir,wind-speeds-text/${path}/current.png"
        return url
    }
}

enum class VaisalaProviderOptions(val value: String, val priority: Int) {
    Satellite("satellite", 1),
    StormCells("stormcells", 2),
    RadarGlobal("radar-global", 3)
}